const FLEEK_STORE_NAME = 'ajiogram';

export { FLEEK_STORE_NAME };
